import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDashboardSummary } from '@euler/model/bi/dashboard';
import { memo } from 'react';
import { View } from 'react-native';
import {
  kBiStackedBelow,
  kBiThreeColumnsFrom,
} from '../functions/biGridLayout';
import { DashboardTile } from './DashboardTile';

/** A titled group of dashboard tiles, in as many columns as fit. */
export const DashboardListSection = memo(
  ({
    title,
    empty,
    items,
    width,
    onOpen,
    onRename,
    onDelete,
  }: {
    title: string;
    empty: string;
    items: BiDashboardSummary[];
    /** The measured content width. */
    width: number;
    onOpen: (item: BiDashboardSummary) => void;
    onRename: (item: BiDashboardSummary) => void;
    onDelete: (item: BiDashboardSummary) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const gap = rpx(12);
    const columns =
      width >= kBiThreeColumnsFrom ? 3 : width >= kBiStackedBelow ? 2 : 1;
    const tileWidth = (width - gap * (columns - 1)) / columns;
    return (
      <View style={{ gap: rpx(10) }}>
        <Typography.Text medium size={rpx(14)} color={aiColors.foreground}>
          {title}
          {items.length ? (
            <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
              {`  ${items.length}`}
            </Typography.Text>
          ) : null}
        </Typography.Text>
        {items.length ? (
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap }}>
            {items.map(item => (
              <View key={item.id} style={{ width: tileWidth }}>
                <DashboardTile
                  item={item}
                  onOpen={() => onOpen(item)}
                  onRename={() => onRename(item)}
                  onDelete={() => onDelete(item)}
                />
              </View>
            ))}
          </View>
        ) : (
          <Typography.Text size={rpx(13)} color={aiColors.mutedForeground}>
            {empty}
          </Typography.Text>
        )}
      </View>
    );
  },
);
